import React from 'react';
import SectionLayout from 'atoms/Layout/Section/SectionLayout';
import PlansEveryStageCardsList from 'organisms/Homepage/PlansEveryStageCardsList/PlansEveryStageCardsList';

const PlansEveryStage = (): JSX.Element => {
  return (
    <SectionLayout
      dataColorMode='dark'
      background='bg-primary'
      maxWidth='width-3xl'
      padding={['spacing-7xl', 'spacing-4xl']}
      paddingSm={['spacing-4xl', 'spacing-xl']}
      data-track-section='plans-every-stage'
    >
      <PlansEveryStageCardsList />
    </SectionLayout>
  );
};

export default PlansEveryStage;
